import { SunIcon, CalendarDaysIcon, ClockIcon } from '@heroicons/react/24/outline';
import { JSX } from 'react';
import { EventData } from '../../types';


interface MealScheduleListProps {
  eventData: EventData;
  mealIcons: { [key: string]: JSX.Element };
}

const MealScheduleList = ({ eventData, mealIcons }: MealScheduleListProps) => (
  <div className="bg-white p-6 rounded-xl shadow-sm">
    <h2 className="text-xl font-semibold mb-6 flex items-center gap-2">
      <SunIcon className="w-6 h-6 text-yellow-500" />
      Meal Schedule
    </h2>
    <div className="space-y-6">
      {eventData.days.map((day, index) => (
        <div key={index} className="bg-blue-50 p-6 rounded-xl">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3">
              <CalendarDaysIcon className="w-5 h-5 text-blue-600" />
              <span className="font-medium text-gray-700">
                {day.date.toLocaleDateString('en-GB', {
                  day: '2-digit',
                  month: 'short',
                  year: 'numeric'
                }).toUpperCase()}
              </span>
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <ClockIcon className="w-4 h-4" />
              {day.startTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} -{' '}
              {day.endTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            {day.meals.map((meal, mealIndex) => (
              <div key={mealIndex} className="flex items-center gap-3 p-3 bg-white rounded-lg border border-gray-200 hover:border-blue-200 transition-colors">
                {mealIcons[meal.name.toLowerCase()] || <SunIcon className="w-5 h-5 text-gray-400" />}
                <span className="font-medium text-gray-700 capitalize">{meal.name}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
);
export default MealScheduleList